/**
 * Returns the complete instances state
 *
 * @param {object} state - Current state
 * @returns {object} - The entire instances state
 */

export const getInstancesORv4 = (state) => state.instancesV4;

export const getORv4ID = (state) => state.user.identity.ORv4ID;
